import axios from 'axios';
import { Message } from 'element-ui';
// import store from '../store/index';
import router from '../router/index';

// axios 配置
axios.defaults.timeout = 5000;
axios.defaults.baseURL = '';

// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    /* if (store.state.token) {
      config.headers.Authorization = `token ${store.state.token}`;
    } */
    if (localStorage.getItem('Authorization')) {
      /* eslint-disable */
      config.headers.Authorization = `Bearer ${localStorage.getItem('Authorization')}`;
    }
    return config;
  },
  (err) => {
    if (err) {
      return Promise.reject(err);
    }
    return Promise.reject();
  },
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response) {
      return response;
    }
    return '';
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          router.push({
            path: '/web/login',
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
        case 500:
          Message({
            message: error.response.data.message,
            type: 'error',
          });
          break;
        /* case 403:
          // 返回 403 清除token信息并跳转到登录页面
          router.push({
            path: '/web/login',
            query: { redirect: router.currentRoute.fullPath },
          });
          break; */
        default:
          break;
      }
      if (error.response.data) {
        // 返回接口返回的错误信息
        return Promise.reject(error.response.data);
      }
      Message({
        message: '服务器正在更新中，请稍后重试或联系客服！',
        type: 'error',
      });
      // return Promise.reject(error)
    } else {
      Message({
        message: '服务器正在更新中，请稍后重试！',
        type: 'error',
      });
    }
    return Promise.reject();
  },
);

export default axios;



// WEBPACK FOOTER //
// ./src/api/interceptors.js